<template>
	<z-scrollDiv class="base-page">
		<div class="base-head" :class="{border:pop}">
			<img class="return" v-show="pop" @click="back" src="~assets/image/back-return.svg">
			<div class="title" :title="title">{{ title | titleLimit }}</div>
			<slot name="tab-title"></slot>
			<!-- <img class="close" v-show="pop" @click="back" src="~assets/image/back-close.svg"> -->
		</div>
		<div class="base-main">
			<slot></slot>
		</div>
	</z-scrollDiv>
</template>

<script>
    export default {
		props:["title","pop"],
		methods:{
			back(){
				this.$router.go(-1);
			},
		}
    }
</script>

<style lang="less">
	@import "~src/assets/less/backless/var.less";
	.z-backStage{
		.base-page{
			@base_head_h: 40px;
			@title_c:#3d3d3d;
			@green:#a4e6f2;

			padding: 0 @basepage_padding;
			box-sizing:border-box;
			height: 100%;

			.base-head{
				box-sizing: border-box;
				height:@base_head_h;
				line-height: @base_head_h - 1;
				position: relative;
				&:after{
					content:"";
					display: block;
					clear: both;
				}
				&.border{
					border-bottom: 1px solid @border_c;
				}
				>div{
					float: left;
				}

				.title{
					font-size:16px;
					color:@title_c;
					padding-left: 10px;
					position: relative;
					&:before{
						content:"";
						display: block;
						width: 2px;
						height: 16px;
						background:@green;
						position: absolute;
						left: 0;
						top: 50%;
						transform: translateY(-50%);
					}
				}

			}

			.return{
				float:left;
				display: block;
				margin-top: @base_head_h/2;
				transform: translateY(-50%);
				margin-right: 10px;
				cursor: pointer;
			}

			// .close{
			// 	position: absolute;
			// 	display: block;
			// 	right: 10px;
			// 	top: 50%;
			// 	transform: translateY(-50%);
			// 	color:#d8d8d8;
			// 	font-size:12px;
			// 	cursor:pointer;
			// }
			
			.base-main{
				height: calc(~"100% - @{base_head_h}");
				padding-top: 0.1px;
				box-sizing: border-box;
			}

			// tab  头
			.base-head >div:nth-of-type(2){
				display:inline-block;
				margin-left: 60px;
				margin-bottom: 0;
				&:after{
					content:"";
					display: block;
					clear: both;
				}
				>div{
					float: left;
					color:#929292;
					font-size:12px;
					line-height: @base_head_h - 2px;
					transition:0.3s;
					cursor:pointer;
					box-sizing: border-box;
					border-bottom: 2px solid transparent;
					&+div{
						margin-left: 30px;
					}
					&:hover{
						color:@black;
					}
					&.active{
						color:@black;
						border-bottom: 2px solid @blue;
					}
				}
			}



		}
	}
</style>





// WEBPACK FOOTER //
// basePage.vue?4c44a740